module.exports = __webpack_public_path__ + "media/images/background_identity_big-800w-28be33e5.jpg";